import script from "./MoveSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveSelect.vue?vue&type=script&setup=true&lang=js"

import "./MoveSelect.vue?vue&type=style&index=0&id=460fd781&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460fd781"]])

export default __exports__